export const pluginTypes = {
  donutHole: 'donutHole',
  lineIntersect: 'lineIntersect',
  lineMarker: 'lineMarker',
  lineChartMarker: 'lineChartMarker',
}
